import axios, {AxiosInstance} from 'axios'
import MyAxiosInstanceAnalyzer from './axiosInstanceAnalyzer'
import {IResponsePresignedUrl} from 'types/preSigned'

export class AnalyzerApiService {
    private analizerApi: AxiosInstance

    client = axios.create({
        baseURL: import.meta.env.VITE_ANALYZER_URL,
    })

    constructor() {
        this.analizerApi = MyAxiosInstanceAnalyzer
    }

    async analyzeProject(
        file: File,
        document_type_id: string,
        regime: '14133' | '13303' = '14133'
    ): Promise<any> {
        const isEstatal = regime === '13303'
        const payload = {
            document_type_id: document_type_id,
            // Regime jurídico da análise. O backend usa este campo para escolher
            // a persona/prompt da IA e a base de conhecimento (Pinecone) corretas.
            database_slug:regime==='14133'?'upload-12-01-26':'licito-estatais',
            doc_analysis_name: file.name,
            file_url: file.name,
            content_type: file.type,
            prompt: isEstatal
                ? 'Você é um analisador de Documentos, especialista em licitações e contratos de empresas estatais regidos pela Lei nº 13.303/2016 (Lei das Estatais).'
                : 'Você é um analisador de Documentos, especialista em licitações regidas pela Lei nº 14.133/2021.',
        }

        const response: {data: IResponsePresignedUrl} =
            await this.analizerApi.post('/document-analysis', payload)

        const uploadData: IResponsePresignedUrl = response.data

        if (!uploadData.file_url) {
            throw new Error(
                'Signed upload URL not provided by analyzer service.'
            )
        }

        console.log('Presigned URL obtida:', uploadData.file_url)

        await axios.put(uploadData.file_url, file, {
            headers: {
                'Content-Type': file.type,
                'x-amz-tagging': uploadData.tagging,
            },
        })

        console.log('File uploaded successfully.')
    }

    async listDocumentAnalyses(
        limit: number = 4,
        offset: number = 0
    ): Promise<any> {
        console.log(
            'Listing document analyses with limit:',
            limit,
            'and offset:',
            offset
        )
        const {data} = await this.analizerApi.get('/document-analysis', {
            params: {
                limit,
                offset,
            },
        })
        console.log('Document analyses retrieved:', data)
        return data
    }

    async listAnalyzedItems(docAnalysisUuid: string): Promise<any> {
        const endpoint = `/analyzed-item/${docAnalysisUuid}/items`
        const {data} = await this.analizerApi.get(endpoint)
        return data
    }

    async downloadAnalyzedItem(
        itemUuid: string,
        fileName: string = 'documento-analisado.pdf'
    ): Promise<void> {
        const response = await this.analizerApi.get(
            `/analyzed-item/${itemUuid}/download`,
            {
                responseType: 'blob',
            }
        )

        const url = window.URL.createObjectURL(new Blob([response.data]))

        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()

        link.parentNode?.removeChild(link)
        window.URL.revokeObjectURL(url)
    }

    async deleteDocumentAnalysis(docAnalysisUuid: string): Promise<void> {
        await this.analizerApi.delete(`/document-analysis/${docAnalysisUuid}`)
    }

    async documentsTypesIds(): Promise<string[]> {
        const {data} = await this.analizerApi.get(
            '/document-analysis/document-type-ids'
        )
        return data
    }
}
